import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/forum'
const resource2 = '/api/v1/forum/check-token'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(forum) {
    return http.post(`${resource}`, forum)
  },
  update(forum, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, forum)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
  checkToken(uuid, token) {
    return http.post(`${resource2}/${uuid}`, token)
  },
}
